import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/reporting-webhooks` subtree. A pass-through, like the sibling
 * `journeys/integrations/all` layout: flag off each child renders the embedded Ember host, flag on
 * it forwards to the migrated URL.
 *
 * The resolver has to sit here rather than on the children. Hydra's ownership pattern claims the
 * `/workspaces/last` form of these URLs, so the embedded app — which resolves the sentinel itself —
 * never mounts to do it for us, and `useHandoffHref` reads the id straight out of the path. Without
 * this the sentinel stays unresolved, the handoff has nothing to forward to, and the page sits on
 * its loading spinner forever.
 *
 * `appBundle` is right here and wrong one level up: these URLs keep the `journeys` segment, so the
 * bundle-aware branch can rebuild the target from the bundle prefix. The migrated routes have no
 * such segment and deliberately omit it.
 */
function JourneysReportingWebhooksLayoutRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <Outlet />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks',
)({
  component: JourneysReportingWebhooksLayoutRoute,
});
